/* eslint-disable camelcase */
import { LINK_PREVIEW_TYPE } from 'wix-rich-content-common';
import { fetchLinkPreviewData } from '@wix/ricos-common';
export default function linkPreviewStrategy(instance) {
    var _a;
    if (!instance)
        return {};
    return {
        config: (_a = {},
            _a[LINK_PREVIEW_TYPE] = {
                fetchData: fetchLinkPreviewData(instance),
            },
            _a),
    };
}
//# sourceMappingURL=linkPreviewStrategy.js.map